import { connect } from 'react-redux';
import Global from '../../../../../store/global-selectors';
import { groupByCarrierAndCustom, allPackageTypes } from '../../../../../fulfillment-planner/package/dropdown/package-group-resolver';
import { PackageDropdown } from '../../../../../fulfillment-planner/package/dropdown';

const mapStateToProps = (state, { selectedPackageTypeId, disabled, packageIds }) => {
  const packages = (Global.selectSellerPackages(state) || []).filter((pkg) => !!pkg && !pkg.isHidden);
  const carriers = Global.selectReferenceDatagetSellerCarriers(state) || [];

  const packageGroups = [allPackageTypes, ...groupByCarrierAndCustom(packages, carriers)];

  return {
    packageGroups,
    selectedPackageIds: packageIds && packageIds.length > 0 ? packageIds : [selectedPackageTypeId],
    disabled,
  };
};

export const PackageTypeContainer = connect(mapStateToProps)(PackageDropdown);
